import { requestGet, requestPost } from '@/utils/request'

export function getEssayGroupMap(params){
  return requestGet('/person/essay/getGroupMap', params);
}
export function getEssayList(params){
  return requestGet('/person/essay/list', params);
}
export function getEssayListPage(params){
  return requestPost(`/person/essay/listPage?pageNum=${params.pageNum}&pageSize=${params.pageSize}`, params);
}
export function getEssayInfo(essayId){
  return requestGet('/person/essay/' + essayId);
}
export function saveEssay(params){
  return requestPost('/person/essay',params);
}
export function hasPermiCheck(params){
  return requestPost('/person/essay/hasPermiCheck',params);
}
